module.exports = __webpack_public_path__ + "static/media/pattern-curve.ae8c0639.svg";